import React from 'react'
import CompletionSummary from 'steps/drag-and-drop/components/CompletionSummary'

export const EndGameModal = ({
  open,
  onClose,
  center,
  everyCorrect,
  totalNumber,
  correctNumber,
  lastStep,
  gameType,
}) => {
  return open ? (
    <div
      className="modal__wrapper"
      style={{
        ...(center && {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }),
      }}
    >
      <CompletionSummary
        everyCorrect={everyCorrect}
        onClose={onClose}
        totalNumber={totalNumber}
        correctNumber={correctNumber}
        lastStep={lastStep}
        gameType={gameType}
      />
    </div>
  ) : (
    <></>
  )
}
